interface Props {
  /** Full tailwind background class, e.g. 'bg-brand-mauve' */
  bgClass: string;
  label: string;
}

export default function PaletteCircle({ bgClass, label }: Props) {
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={`inline-block h-8 w-8 sm:h-9 sm:w-9 rounded-full ring-1 ring-brand-ink/10 ${bgClass}`}
    />
  );
}
